import { Order } from "@web-app/types";

import OrderTimeline from "./OrderTimeline";

type OrderTimelineTabProps = {
  order: Order;
};

export default function OrderTimelineTab({ order }: OrderTimelineTabProps) {
  return (
    <div className="px-2 md:px-4 lg:px-6 pb-10">
      <OrderTimeline order={order} />
    </div>
  );
}
